import {mapState} from 'vuex';
import {EventBus} from '../lib/event-bus'

export default {
    data() {
        return {
            expandedTopic: false,
            itemHighlighted: false,
        }
    },

    props: {
        topic: {},
        singleTopic: {
            default: false
        },
        focusCommentByHashId: false,
        viewType: false,
        post_type: {
            default: 'text'
        }
    },

    computed: {
        ...mapState([
            'modalData',
            'displayMode'
        ]),

        isUsersInvisibleIntroductionTopic() {
            if (this.topic.status === 'invisible') {
                if (this.topic.user().id === user.id) {
                    return true;
                }
            }

            return false;
        },

        showViewsCount() {
            if (this.isUsersInvisibleIntroductionTopic) {
                return false;
            }

            return true;
        },

        showLikeIcon() {
            if (this.isUsersInvisibleIntroductionTopic === true) {
                return 'none';
            }

            return false;
        }
    },

    methods: {
        expandTopic(topic) {
            EventBus.$emit('prevent-from-closing', true);
            this.expandedTopic = true;

            if (topic) {
                this.$store.dispatch(
                    {
                        type: 'activeDataAction',
                        data: {
                            model: 'Topic',
                            crud_method: 'update',
                            custom_verb: 'post',
                            sub_path: '/api/v3/notifications/track',
                            save_data: {
                                'conversation': topic.id,
                            }
                        }
                    }
                );
            }

            //find mentions
            //$('.post-wrapper').mentionify();

        },
    },

    //show entire topic if it is a single topic page
    created() {
        if (this.singleTopic) {
            this.expandTopic();
        }

        //hide moodview on escape
        if (this.viewType === 'moodview') {
            const keyHandler = (e) => {
                if (e.key === `Escape`) {
                    this.closeMoodview();
                }
            };

            document.addEventListener(`keydown`, keyHandler);

            this.$once(`hook:destroyed`, () => {
                document.removeEventListener(`keydown`, keyHandler);
            });
        }
    }
}